import Component from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/uni_modules/uni-icons/components/uni-icons/uni-icons.vue'
wx.createComponent(Component)